@if (activeHandoffId) {
<div class="conversation-head">
  <div class="conversation-head-identity">
    <span class="case-avatar"
      [style.background]="avatarColor(customerName)"
      [style.color]="'#fff'">{{ customerInitials }}</span>

    <span class="conversation-head-copy">
      <span class="conversation-head-name">{{ customerName }}</span>
      <span class="conversation-head-meta">
        <span class="conversation-order-code">{{ primaryCaseCode }}</span>
        <span class="conversation-head-phone">{{ customerPhone }}</span>
      </span>
    </span>
  </div>

  <div class="conversation-head-actions">
    <a class="primary-teal-btn" [routerLink]="pastOrdersRoute">Past Orders</a>

    <button mat-icon-button class="mute-icon-btn" [matMenuTriggerFor]="muteMenu" aria-label="Customer options">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
        <path d="M47.16,21.221l-5.91-0.966c-0.346-1.186-0.819-2.326-1.411-3.405l3.45-4.917c0.279-0.397,0.231-0.938-0.112-1.282 l-3.889-3.887c-0.347-0.346-0.893-0.391-1.291-0.104l-4.843,3.481c-1.089-0.602-2.239-1.08-3.432-1.427l-1.031-5.886 C28.607,2.35,28.192,2,27.706,2h-5.5c-0.49,0-0.908,0.355-0.987,0.839l-0.956,5.854c-1.2,0.345-2.352,0.818-3.437,1.412l-4.83-3.45 c-0.399-0.285-0.942-0.239-1.289,0.106L6.82,10.648c-0.343,0.343-0.391,0.883-0.112,1.28l3.399,4.863 c-0.605,1.095-1.087,2.254-1.438,3.46l-5.831,0.971c-0.482,0.08-0.836,0.498-0.836,0.986v5.5c0,0.485,0.348,0.9,0.825,0.985 l5.831,1.034c0.349,1.203,0.831,2.362,1.438,3.46l-3.441,4.813c-0.284,0.397-0.239,0.942,0.106,1.289l3.888,3.891 c0.343,0.343,0.884,0.391,1.281,0.112l4.87-3.411c1.093,0.601,2.248,1.078,3.445,1.424l0.976,5.861C21.3,47.647,21.717,48,22.206,48 h5.5c0.485,0,0.9-0.348,0.984-0.825l1.045-5.89c1.199-0.353,2.348-0.833,3.43-1.435l4.905,3.441 c0.398,0.281,0.938,0.232,1.282-0.111l3.888-3.891c0.346-0.347,0.391-0.894,0.104-1.292l-3.498-4.857 c0.593-1.08,1.064-2.222,1.407-3.408l5.918-1.039c0.479-0.084,0.827-0.5,0.827-0.985v-5.5C47.999,21.718,47.644,21.3,47.16,21.221z M25,32c-3.866,0-7-3.134-7-7c0-3.866,3.134-7,7-7s7,3.134,7,7C32,28.866,28.866,32,25,32z"/>
      </svg>
    </button>

    <mat-menu #muteMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="muteAction.emit('15')">
        <mat-icon>volume_off</mat-icon>Mute for 15 min
      </button>
      <button mat-menu-item (click)="muteAction.emit('30')">
        <mat-icon>volume_off</mat-icon>Mute for 30 min
      </button>
      <button mat-menu-item (click)="muteAction.emit('block')">
        <mat-icon>block</mat-icon>Block User
      </button>
    </mat-menu>
  </div>
</div>
}

@if (loading) {
  <div class="loading-state">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
} @else if (!demoMode && !activeHandoffId) {
  <div class="no-cases-placeholder">
    <mat-icon aria-hidden="true">inbox</mat-icon>
    <span>No active cases</span>
    <p>All cases have been returned to Eldara AI.</p>
  </div>
} @else {
  <div class="messages" #messagesEl>
    @for (message of messages; track message.id) {
      @if (message.id === firstUnreadMessageId) {
        <div class="unread-divider"><span>Unread messages</span></div>
      }
      @if (isSystemMessage(message)) {
        <article class="system-card">
          <div class="system-icon">
            <mat-icon aria-hidden="true">inventory_2</mat-icon>
          </div>
          <div class="system-copy">
            <div class="message-text">{{ message.text }}</div>
            <span class="message-time">{{ messageSenderLabel(message) }} · {{ message.created_at | date: 'h:mm a' }}</span>
          </div>
        </article>
      } @else {
        <article class="message-row" [class.operator]="isOperatorMessage(message)">
          <div class="message-avatar"
            [class.operator]="isOperatorMessage(message)"
            [class.ai]="message.sender_type === 'AI'"
            [style.background]="message.sender_type === 'USER' ? avatarColor(customerName) : null"
            [style.color]="message.sender_type === 'USER' ? '#fff' : null">
            {{ messageAvatarLabel(message) }}
          </div>

          <div class="message-bubble" [class.operator]="isOperatorMessage(message)" [class.ai]="message.sender_type === 'AI'">
            @if (message.attachments?.length) {
              <div class="message-attachments">
                @for (att of message.attachments; track att.id) {
                  @if (att.mime_type.startsWith('image/')) {
                    <img class="message-attachment-image" [src]="att.url" [alt]="att.original_filename || 'image'" loading="lazy" />
                  } @else {
                    <a class="message-attachment-file" [href]="att.url" target="_blank" rel="noopener">
                      <mat-icon aria-hidden="true">description</mat-icon>
                      <span>{{ att.original_filename || 'Attachment' }}</span>
                    </a>
                  }
                }
              </div>
            }
            @if (message.text) {
              <div class="message-text">{{ message.text }}</div>
            }
            <span class="message-time">{{ message.created_at | date: 'h:mm a' }}</span>
          </div>
        </article>
      }
    }
  </div>
}

@if (activeHandoffId) {
<div class="composer-wrap">
  <input
    #imageInput
    type="file"
    accept="image/jpeg,image/png"
    class="visually-hidden"
    (change)="onImageSelected($event)"
  />

  @if (pendingAttachment()) {
    <div class="composer-attachment-preview">
      <mat-icon aria-hidden="true">image</mat-icon>
      <span class="composer-attachment-name">{{ pendingAttachment()!.name }}</span>
      <button type="button" class="composer-attachment-remove" aria-label="Remove attachment" (click)="removePendingAttachment()">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="send()" class="composer">
    <button
      type="button"
      class="composer-icon"
      aria-label="Attach image"
      [disabled]="attachmentUploading() || !!pendingAttachment()"
      (click)="imageInput.click()"
    >
      @if (attachmentUploading()) {
        <mat-progress-spinner diameter="20" mode="indeterminate" />
      } @else {
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.0778 6.65388V16.2692C14.0778 17.4162 13.148 18.3461 12.0009 18.3461C10.8538 18.3461 9.92397 17.4162 9.92397 16.2692V8.15388M14.0778 6.65388L14.0773 14.9422M14.0778 6.65388C14.0778 4.77397 12.5533 3.25 10.6734 3.25C8.7935 3.25 7.26953 4.77397 7.26953 6.65388L7.26953 14.9422M16.7314 10.0578V17.0192C16.7314 19.6319 14.6134 21.75 12.0006 21.75C9.38787 21.75 7.26981 19.6319 7.26981 17.0192V10.0578" stroke="#323544" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
    </button>

    <textarea
      #composerTextarea
      class="composer-input"
      formControlName="text"
      placeholder="Type a message..."
      autocomplete="off"
      rows="1"
      (input)="onComposerInput()"
      (keydown.enter)="onComposerEnter($event)"
    ></textarea>

    <button class="primary-green-btn primary-green-btn--send-message" type="submit"
      [disabled]="(!form.value.text?.trim() && !pendingAttachment()) || sending() || attachmentUploading()">
      Send
    </button>
  </form>

  @if (sendError()) {
    <div class="composer-error">{{ sendError() }}</div>
  }
</div>
}
